import { View } from 'react-native'
import styled, { useTheme } from 'styled-components'
import { ArrowsOutsideCarousel } from '../../../elements/carousels/ArrowsOutsideCarousel/ArrowsOutsideCarousel'
import { Image } from '../../../elements/images/Image/Image'
import { Paragraph } from '../../../elements/typography'

const Slide = styled(View)`
  background-color: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacing.xsmall}px;
  align-items: center;
  min-height: 220px;
`

const AuthorLogo = styled(Image).attrs((props) => ({
  height: props.width * 0.5611,
}))`
  margin: 0 auto;
`

const Caption = styled(Paragraph)`
  margin: 0 ${(props) => props.theme.spacing.medium}px ${(props) => props.theme.spacing.medium}px;
  font-size: ${(props) => props.theme.fontSizes.large}px;
  color: ${(props) => props.theme.colors.black};
  text-align: center;
`

const items = [
  {
    text: 'The UK outlet offers a bargain platform for indie films...',
    image: 'web/press/the_guardian',
  },
  {
    text: 'Like Netflix, but only for movies. And curated.',
    image: 'web/press/the_daily_dot',
  },
  {
    text: 'Indie moviegoers are in for a treat',
    image: 'web/press/fox_business',
  },
  {
    text: 'A very affordable way to watch something a little different.',
    image: 'web/press/trusted_reviews',
  },
]

export const QuoteCarousel = ({ style }) => {
  const theme = useTheme()
  const gutter = theme.spacing.large * 2
  return (
    <ArrowsOutsideCarousel
      arrowScale={1.2}
      arrowColor="grayLighte"
      autoplay
      autoplaySpeed={4000}
      slidesToShow={1}
      slidesToScroll={1}
      style={style}
      items={items}
      renderItem={(item, _, width) => (
        <Slide>
          <AuthorLogo publicId={item.image} width={width - gutter} />
          <Caption>"{item.text}"</Caption>
        </Slide>
      )}
    />
  )
}
